import type { Variants } from 'framer-motion';

export const containerVariants: Variants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.07, delayChildren: 0.02 } },
};

export const itemVariants: Variants = {
  hidden: { opacity: 0, y: 10 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.32, ease: [0.22, 1, 0.36, 1] } },
};

export const expandVariants: Variants = {
  collapsed: { height: 0, opacity: 0 },
  expanded: { height: 'auto', opacity: 1, transition: { duration: 0.25, ease: [0.22, 1, 0.36, 1] } },
};

/**
 * Row/card list entries (products table rows, product mobile cards, FAQ
 * entries). Deliberately opacity+y only rather than opacity+height: this
 * variant is shared by <tr> rows (in the desktop products table) and by plain
 * block-level cards (mobile products, FAQ list) — table rows don't reliably
 * animate `height` across browsers, so we keep one variant that is safe on
 * both element types instead of branching the animation by list type.
 */
export const listItemVariants: Variants = {
  hidden: { opacity: 0, y: 8 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.28, ease: [0.22, 1, 0.36, 1] } },
  exit: { opacity: 0, transition: { duration: 0.18, ease: [0.22, 1, 0.36, 1] } },
};
